import {SET_PROVIDER_PROFILE_DATA, SET_CURRENT_STATE_DATA, SET_PNB_STRATEGY_DATA, SET_PNB_DOC_UPDATE_TYPE, ENABLE_SAVE_AND_EXIT, FETCH_PNB_HEADER_DATA, FETCH_PNB_HEADER_DATA_SUCCESS, SET_CURRENT_STATE_MODAL, SET_CURRENT_STATE_EDITABLE, SET_PROVIDER_PROFILE_EDITABLE, SET_PNB_STRATEGY_EDITABLE, SET_DOCUMENT_ID, REMOVE_TEMP_DATA, UPLOAD_TO_IMPACT_REQUEST, UPLOAD_TO_IMPACT_SUCCESS, UPLOAD_TO_IMPACT_FAILURE, UPLOAD_TO_IMPACT_RESET} from "@src/middleware/actions/actionTypes";
import { FETCH_USER_ACTION_FAIL, FETCH_USER_ACTION_SUCCESS } from "@src/middleware/actions/pnbActions/pnsActions";

const initialState = {
  pnsStrategyData: {},
  pnsErrorData: {},
  ProviderProfile: {},
  CurrentState: {},
  PnbStrategy: {},
  pnbHeaderData: {},
  updateType: "",
  refreshValue: "",
  documentId: "",
  enableSaveAndExit: {
    editedProviderProfile: false,
    iditedCurrentState: false,
    editedPnbStrategy: false,
  },
  currentTime: "",
  ProviderProfileTempData: {},
  CurrentStateTempData: {},
  PnbStrategyTempData: {},
  templateType:'',
  headerData: {},
  headerName: '',
  showCurrentStateErrorModal: false,
  isEditableCurrentState: false,
  isEditableProviderProfile: false,
  isEditablePnbStrategy: false,
  uploadToImpactLoading: false,
  uploadToImpactSuccess: false,
  uploadToImpactError: false,
};
const pnbReducer = (state = initialState, action: any) => {
//  console.log( action.payload, "Action payload in reducer");
  switch (action.type) {
    case FETCH_USER_ACTION_SUCCESS:
      return {
        ...state,
        pnsStrategyData: action.payload,
        pnsErrorData: {},
        ProviderProfile: action.payload.providerProfile,
        CurrentState: action.payload.currentState,
        PnbStrategy: action.payload.providerNegotioationStratergy,
        documentId: state.documentId ? state.documentId : action.payload.documentId,
        currentTime: action.payload.currentTime,
        templateType: state.templateType ? state.templateType : action.payload.templateType,
        headerData: action?.payload?.headerData,
        headerName: action?.payload?.headerName,
      };
      case FETCH_USER_ACTION_FAIL:
      return {
        ...state,
        pnsStrategyData: {},
        pnsErrorData: action.payload,
      };
    case SET_PROVIDER_PROFILE_DATA:
      return {
        ...state,
        ProviderProfile: action.payload.formData,
        updateType: action.payload.updateType,
        refreshValue: action.payload.refreshValue,
        ProviderProfileTempData: action.payload.formData,
    };
    case SET_CURRENT_STATE_DATA:
      return {
        ...state,
        CurrentState: action.payload.formData,
        updateType: action.payload.updateType,
        refreshValue: action.payload.refreshValue,
        CurrentStateTempData: action.payload.formData,
    };
    case SET_PNB_STRATEGY_DATA:
      return {
        ...state,
        PnbStrategy: action.payload.formData,
        updateType: action.payload.updateType,
        refreshValue: action.payload.refreshValue,
        PnbStrategyTempData: action.payload.formData,
    };
    case SET_DOCUMENT_ID:
      return {
        ...state,
        documentId: action.payload,
      };
    case SET_PNB_DOC_UPDATE_TYPE:
      return {
        ...state,
        updateType: action.payload.updateType,
        refreshValue: action.payload.refreshValue,
      }
    case ENABLE_SAVE_AND_EXIT:
      return {
        ...state,
        enableSaveAndExit: {...state.enableSaveAndExit, ...action.payload},
      };
    case FETCH_PNB_HEADER_DATA_SUCCESS:
      return {
        ...state,
        pnbHeaderData: action.payload,
      };
    case SET_CURRENT_STATE_MODAL:
      return {
        ...state,
        showCurrentStateErrorModal: action.payload,
      };
    case SET_CURRENT_STATE_EDITABLE:
      return {
        ...state,
        isEditableCurrentState: action.payload,
      };
    case SET_PROVIDER_PROFILE_EDITABLE:
      return {
        ...state,
        isEditableProviderProfile: action.payload,
      };
    case SET_PNB_STRATEGY_EDITABLE:
      return {
        ...state,
        isEditablePnbStrategy: action.payload,
      };
    case REMOVE_TEMP_DATA:
      return {
        ...state,
        ProviderProfileTempData: {},
        CurrentStateTempData: {},
        PnbStrategyTempData: {},
      };
    case UPLOAD_TO_IMPACT_REQUEST:
      return {
        ...state,
        uploadToImpactLoading: true,
        uploadToImpactSuccess: false,
        uploadToImpactError: false,
      };
    case UPLOAD_TO_IMPACT_SUCCESS:
      return {
        ...state,
        uploadToImpactLoading: false,
        uploadToImpactSuccess: true,
        uploadToImpactError: false,
      };
    case UPLOAD_TO_IMPACT_FAILURE:
      return {
        ...state,
        uploadToImpactLoading: false,
        uploadToImpactSuccess: false,
        uploadToImpactError: true,
      };
    case UPLOAD_TO_IMPACT_RESET:
      return {
        ...state,
        uploadToImpactLoading: false,
        uploadToImpactSuccess: false,
        uploadToImpactError: false,
      };
    default:
      return state;
  }
};


export default pnbReducer;